import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  primaryColor: '',
  logoUrl: '',
  loginOptions: {},
  isDark: false,
  brandName: '',
  brokerName: '',
  description: '',
  supportPhone: '',
  supportEmail: '',
  websiteUrl: '',
  brokerAddress: '',
  legalName: '',
  mobileAppLinks: {
    ios: '',
    android: '',
    is_enabled: false
  },
  ssoUrl: '',
  paymentEnforcementConfig: {
    temporaryAppAccessSuspension: false,
  }
};

const theme = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.primaryColor = action.payload.primaryColor;
      state.logoUrl = action.payload.logoUrl;
      state.loginOptions = action.payload.loginOptions;
      state.isDark = action.payload.isDark;
      state.brandName = action.payload.brandName;
      state.brokerName = action.payload.brokerName;
      state.description = action.payload.description;
      state.supportPhone = action.payload.supportPhone;
      state.supportEmail = action.payload.supportEmail;
      state.websiteUrl = action.payload.websiteUrl;
      state.brokerAddress = action.payload.brokerAddress;
      state.legalName = action.payload.legalName;
      if (action.payload.mobileAppLinks) {
        state.mobileAppLinks = action.payload.mobileAppLinks;
      }
      state.ssoUrl = action.payload.ssoUrl;
    },
    setPaymentEnforcementConfig: (state, action) => {
      state.paymentEnforcementConfig.temporaryAppAccessSuspension =
        action.payload.temporaryAppAccessSuspension === true;
    },
  },
});

export const themeActions = theme.actions;

export default theme.reducer;
